import {Box, Stack, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {HeadphonesIcon, Sad01Icon, TrendingUpIcon} from "@hugeicons/core-free-icons";
import {c, mono, softShadow, purpleGradient} from "../landingTokens";
import {Section, Eyebrow, SectionHeading, Dim} from "./Shell";

const PROBLEMS = [
  {
    icon: HeadphonesIcon,
    title: "Overwhelmed agents",
    body: "High call volumes drive burnout, attrition and endless retraining cycles.",
  },
  {
    icon: Sad01Icon,
    title: "Frustrated customers",
    body: "Long holds and repeat questions erode loyalty with every single call.",
  },
  {
    icon: TrendingUpIcon,
    title: "Rising costs",
    body: "Headcount becomes the only lever — and it doesn't scale with demand.",
  },
];

export const ProblemStatement = () => (
  <Section label="Problem" sx={{pt: {xs: 8, md: 14.75}, borderTop: `1px solid ${c.line}`}}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {xs: "1fr", md: "minmax(0,0.82fr) minmax(0,1.18fr)"},
        gap: {xs: 5, md: 8},
        alignItems: "start",
      }}
    >
      {/* Left — editorial intro */}
      <Box className="reveal" sx={{position: {md: "sticky"}, top: {md: 108}}}>
        <Eyebrow>The problem</Eyebrow>
        <SectionHeading sx={{maxWidth: 480}}>
          Is your contact center<br />
          <Dim>drowning in calls?</Dim>
        </SectionHeading>
        <Typography sx={{mt: 3, maxWidth: 420, fontSize: {xs: 16, md: 17}, lineHeight: 1.6, color: c.inkSoft}}>
          Call volumes climb, wait times stretch, and the only lever left is hiring. It's
          expensive, slow, and it burns out your best agents.
        </Typography>
      </Box>

      {/* Right — the three tensions, as soft cards */}
      <Stack className="reveal-stagger" gap={2.25}>
        {PROBLEMS.map((p, i) => (
          <Stack
            key={p.title}
            direction="row"
            gap={2.5}
            sx={{
              position: "relative",
              bgcolor: c.white,
              borderRadius: "22px",
              p: {xs: 3, md: 3.5},
              boxShadow: softShadow,
            }}
          >
            <Box
              sx={{
                flexShrink: 0,
                width: 52,
                height: 52,
                borderRadius: "15px",
                display: "grid",
                placeItems: "center",
                background: purpleGradient,
                color: "#fff",
                boxShadow: "0 12px 24px -12px rgba(98,88,232,0.7)",
              }}
            >
              <HugeiconsIcon icon={p.icon} size={24} aria-hidden="true" />
            </Box>
            <Box>
              <Typography sx={{fontSize: 20, letterSpacing: "-0.02em", fontWeight: 600, mb: 0.75}}>
                {p.title}
              </Typography>
              <Typography sx={{fontSize: 15, lineHeight: 1.55, color: c.inkSoft}}>{p.body}</Typography>
            </Box>
            <Typography
              aria-hidden
              sx={{
                position: "absolute",
                top: {xs: 14, md: 18},
                right: {xs: 16, md: 20},
                fontFamily: mono,
                fontSize: 11,
                letterSpacing: "0.14em",
                color: c.inkMuted,
              }}
            >
              0{i + 1}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  </Section>
);
